<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content modal-detail">
      <div class="modal-header">
        <h3>📸 جزئیات پست</h3>
        <button class="btn-close" @click="$emit('close')">✕</button>
      </div>

      <div class="modal-body">
        <div class="detail-content">
          <div :class="['type-badge', post.type]" style="margin-bottom: 16px;">
            {{ typeLabel }}
          </div>

          <!-- قبل/بعد -->
          <div v-if="post.type === 'before_after'" class="detail-before-after">
            <div class="detail-ba-item">
              <span class="detail-label before">قبل</span>
              <img v-if="post.media[0]" :src="post.media[0].url" alt="قبل" />
            </div>
            <div class="detail-ba-item">
              <span class="detail-label after">بعد</span>
              <img v-if="post.media[1]" :src="post.media[1].url" alt="بعد" />
            </div>
          </div>

          <!-- اسلایدی -->
          <div v-else-if="post.type === 'slide'" class="detail-slide">
            <div class="slide-counter">
              {{ currentSlide + 1 }} / {{ post.media.length }}
            </div>
            <img v-if="post.media[currentSlide]" :src="post.media[currentSlide].url" alt="اسلاید" />
            <button class="slide-nav prev" @click="prevSlide" :disabled="currentSlide <= 0">‹</button>
            <button class="slide-nav next" @click="nextSlide" :disabled="currentSlide >= post.media.length - 1">›</button>
            <div class="slide-dots">
              <span
                  v-for="(m, i) in post.media"
                  :key="i"
                  :class="['dot', { active: i === currentSlide }]"
                  @click="currentSlide = i"
              ></span>
            </div>
          </div>

          <!-- تکی -->
          <div v-else class="detail-single">
            <img v-if="post.media[0]" :src="post.media[0].url" alt="عکس" />
          </div>

          <p v-if="post.caption" class="detail-caption">{{ post.caption }}</p>

          <div v-if="post.lines.length > 0" class="post-lines">
            <span v-for="line in post.lines" :key="line.id" class="line-tag">
              {{ line.title }}
            </span>
          </div>

          <div class="detail-meta">
            {{ formatDate(post.created_at) }}
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-secondary" @click="$emit('close')">بستن</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostDetailModal',

  props: {
    post: {
      type: Object,
      required: true
    }
  },

  data: function() {
    return {
      currentSlide: 0
    };
  },

  computed: {
    typeLabel: function() {
      var map = {
        single: '🖼 تکی',
        before_after: '↔️ قبل/بعد',
        slide: '🎠 اسلایدی'
      };
      return map[this.post.type] || this.post.type;
    }
  },

  methods: {
    prevSlide: function() {
      if (this.currentSlide > 0) this.currentSlide--;
    },

    nextSlide: function() {
      if (this.currentSlide < this.post.media.length - 1) this.currentSlide++;
    },

    formatDate: function(date) {
      if (!date) return '-';
      var d = new Date(date);
      return d.getFullYear() + '/' +
          String(d.getMonth() + 1).padStart(2, '0') + '/' +
          String(d.getDate()).padStart(2, '0') + ' - ' +
          String(d.getHours()).padStart(2, '0') + ':' +
          String(d.getMinutes()).padStart(2, '0');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-detail {
  max-width: 600px;
  width: 100%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  color: #2c3e50;
}

.btn-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #909399;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.type-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  background: #f5f7fa;
  color: #2c3e50;
}

.type-badge.single { color: #409eff; }
.type-badge.before_after { color: #e6a23c; }
.type-badge.slide { color: #67c23a; }

.detail-before-after {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.detail-ba-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.detail-ba-item img {
  width: 100%;
  display: block;
}

.detail-label {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 3px 12px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  color: white;
  z-index: 2;
}

.detail-label.before { background: rgba(230, 162, 60, 0.9); }
.detail-label.after { background: rgba(103, 194, 58, 0.9); }

.detail-slide {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.detail-slide img {
  width: 100%;
  display: block;
}

.slide-counter {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  z-index: 2;
}

.slide-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.slide-nav:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.slide-nav.prev { right: 10px; }
.slide-nav.next { left: 10px; }

.slide-dots {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 2;
}

.slide-dots .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.slide-dots .dot.active {
  background: white;
  width: 24px;
  border-radius: 4px;
}

.detail-single img {
  width: 100%;
  border-radius: 8px;
  display: block;
}

.detail-caption {
  margin: 0;
  font-size: 14px;
  color: #303133;
  line-height: 1.7;
}

.post-lines {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.line-tag {
  padding: 2px 10px;
  background: #f0f9eb;
  color: #67c23a;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.detail-meta {
  font-size: 12px;
  color: #909399;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.btn-secondary {
  padding: 10px 24px;
  background: #909399;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

@media (max-width: 768px) {
  .detail-before-after {
    grid-template-columns: 1fr;
  }
}
</style>